import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Icon, Tooltip } from '@rocketlane/ui';
import { useMediaState } from '@vidstack/react';
import { useVideoPlayerContext } from '../../player-context';

type PlayerControlButtonProps = {
  icon: IconDefinition;
  tooltipContent?: React.ReactNode;
  onClick: () => void;
};
export const PlayerControlButton = ({
  icon,
  onClick,
  tooltipContent,
}: PlayerControlButtonProps) => {
  const { playerRef } = useVideoPlayerContext();
  const isFullscreen = useMediaState('fullscreen', playerRef!);

  return (
    <Tooltip content={tooltipContent}>
      <div
        className="flex items-center justify-center h-[32px] w-[32px] cursor-pointer"
        onClick={onClick}
      >
        <Icon icon={icon} size={isFullscreen ? '1.5x' : '1x'} />
      </div>
    </Tooltip>
  );
};
